import IconOptionsEnum from "../enums/IconOptionsEnum";

export const getColorByShippingStatusId = (statusId) => {
  switch (statusId) {
    case 11:
      return IconOptionsEnum.DELIVERED;
    case 12:
      return IconOptionsEnum.PENDING;
    case 13:
      return IconOptionsEnum.ON_ROUTE;
    default:
      return IconOptionsEnum.UNDELIVERED;
  }
}

export const getColorByCollectStatusId = (statusId) => {
  switch (statusId) {
    case 11:
      return IconOptionsEnum.DELIVERED_OWN_COLLECT;
    case 12:
    case 13:
      return IconOptionsEnum.PENDING_OWN_COLLECT;
    default:
      return IconOptionsEnum.UNDELIVERED_OWN_COLLECT;
  }
}


export const getIconAndColor = (location) => {
  const { icon_type, status } = location;

  switch (icon_type) {
    case "driver":
      return IconOptionsEnum.DRIVER;

    case "package":
      return getColorByShippingStatusId(status);

    case "ownCollect":
      return getColorByCollectStatusId(status);

    default:
      return IconOptionsEnum.DEFAULT;
  }
};

